(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/serversidehelper/assets/javascripts/serversiderendering.js') >= 0) return;  svs.modules.push('/components/app/serversidehelper/assets/javascripts/serversiderendering.js');
"use strict";


(function (Backbone, _, svs) {
  'use strict';

  svs.app.ServerSideHelper.ServerSideRendering = Marionette.Behavior.extend({
    onServersideInitialized() {
      if (this.view.getOption('preRendered')) {
        this.view.triggerMethod('attach');
        if (this.view instanceof Marionette.View && typeof this.getOption('regionSetup') === 'function') {
          const settingsArray = Object.keys(this.getOption('regionSetup').call(this.view));
          for (let i = 0, iLen = settingsArray.length; i < iLen; i++) {
            const region = this.view.getRegion(settingsArray[i]);
            if (region && region.currentView) {
              const currentView = region.currentView;
              region.triggerMethod('show');
              if (currentView._firstTimeServerSideRender === undefined) {
                region.currentView.triggerMethod('attach');
              } else {
                region.currentView.triggerMethod('serverside:initialized');
              }
            }
          }
        } else if (this.view instanceof Marionette.CollectionView) {
          this.view.children.each(view => {
            if (view._firstTimeServerSideRender === undefined) {
              view.triggerMethod('attach');
            } else {
              view.triggerMethod('serverside:initialized');
            }
          });
        }
      }
    },
    onAttachServerside() {
      let emptyView;
      let setting;
      let settings;
      let settingsArray;
      if (this.view.getOption('preRendered')) {
        if (this.view instanceof Marionette.View && typeof this.getOption('regionSetup') === 'function') {
          settings = this.getOption('regionSetup').call(this.view);
          settingsArray = Object.keys(settings);
          for (let i = 0, iLen = settingsArray.length; i < iLen; i++) {
            setting = settings[settingsArray[i]];
            const region = this.view.getRegion(settingsArray[i]);
            if (!region) {
              svs.app.ServerSideHelper.logger.error("Region ".concat(settingsArray[i], " was not defined in the view."));
            } else if (!setting.view) {
              svs.app.ServerSideHelper.logger.error("View to initialize in region ".concat(settingsArray[i], " was not defined. Check regionSetup for typos."));
            } else if (region.$el.length) {
              const viewInstnace = new setting.view(_.extend({}, setting.options, {
                preRendered: true,
                el: region.$el.children().length > 1 ? region.$el : region.$el.children().first()
              }));
              region.currentView = viewInstnace;
              svs.app.ServerSideHelper.utils.initView(viewInstnace, region);
              this.view._proxyChildViewEvents(viewInstnace);
            } else {
              svs.app.ServerSideHelper.logger.error("Region ".concat(settingsArray[i], " was not found in the DOM."));
            }
          }
        } else if (this.view instanceof Marionette.CollectionView) {
          if (this.view.collection.isEmpty() && this.view.emptyView) {
            emptyView = new this.view.emptyView(_.extend({
              el: this.$el.children(':nth-child(1)'),
              preRendered: true,
              model: new Backbone.Model()
            }, this.view.childViewOptions && this.view.childViewOptions() || undefined));
            this.view._addChild(emptyView);
          } else if (this.view.$el.children().length !== this.view.collection.length) {
            this.view.$el.html('');
            this.view.render();
          } else if (this.view.$el.children().length === 1 && this.view.collection.length === 1 && this.$el.children()[0].dataset && this.$el.children()[0].dataset.ssremptyview) {
            this.view.$el.html('');
            this.view.render();
          } else {
            this.view.collection.each(function (model, index) {
              const view = new this.childView(_.extend({
                el: this.$el.children().length ? this.$el.children(":nth-child(".concat(index + 1, ")")) : undefined,
                preRendered: true,
                model
              }, this.childViewOptions && this.childViewOptions() || undefined));
              this._addChild(view);
              if (model.hasChanged()) {
                view.render();
              }
            }, this.view);
          }
          this.view._initialEvents();
          this.view._getChildViewContainer();
          this.view._isRendered = true;
          this.view._isAttached = true;
        }
      }
    },
    initialize() {
      if (this.view.getOption('preRendered')) {
        this.view._firstTimeServerSideRender = true;
      }
    },
    onDomRefresh() {
      if (this.view instanceof Marionette.View && (!this.view.getOption('preRendered') || this.view._isServersideAttached)) {
        if (!this.view._firstTimeServerSideRender && typeof this.getOption('regionSetup') === 'function') {
          const settings = this.getOption('regionSetup').call(this.view);
          const settingsArray = Object.keys(settings);
          for (let i = 0, iLen = settingsArray.length; i < iLen; i++) {
            const setting = settings[settingsArray[i]];
            this.view.getRegion(settingsArray[i]).show(new setting.view(setting.options));
          }
        }
        this.view._firstTimeServerSideRender = false;
      }
    }
  });
  svs.app.behaviors.ServerSideRendering = svs.app.ServerSideHelper.ServerSideRendering;
})(Backbone, _, svs);

 })(window);